import { render, staticRenderFns } from "./payment-checkbox-income.vue?vue&type=template&id=0cc5e0c0&scoped=true"
import script from "./payment-checkbox-income.vue?vue&type=script&lang=js"
export * from "./payment-checkbox-income.vue?vue&type=script&lang=js"
import style0 from "./payment-checkbox-income.vue?vue&type=style&index=0&id=0cc5e0c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc5e0c0",
  null
  
)

export default component.exports